import React, { useContext, useState } from 'react';
import dayjs from 'dayjs';
import {
  Box, Button, IconButton,
} from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CancelOutlined from '@mui/icons-material/CancelOutlined';
import { CartContext } from 'constants/contexts';
import ScheduleOrderOverlay from 'components/ScheduleOrderOverlay';

function ScheduleButton({
  merchant,
  ...props
}) {
  const cart = useContext(CartContext);
  const [schedulingOpen, setSchedulingOpen] = useState(false);
  function getButtonVariant() {
    if (cart.scheduledTime) {
      return 'text';
    }
    if (!merchant.takeout) {
      return 'contained';
    }
    return 'outlined';
  }
  return (
    <ScheduleOrderOverlay
      merchant={merchant}
      onClose={() => setSchedulingOpen(false)}
      open={schedulingOpen}
      triggerAction={(
        <Box display="flex" alignItems="center" gap={1} {...props}>
          <Button
            loadingPosition="start"
            startIcon={<AccessTimeIcon />}
            onClick={() => setSchedulingOpen(true)}
            variant={getButtonVariant()}
          >
            {cart.scheduledTime &&
            `Scheduled for: ${dayjs(cart.scheduledTime).format(
              'ddd, DD MMM hh:mm A',
            )}`}
            {!cart.scheduledTime && 'Schedule for later'}
          </Button>
          {cart.scheduledTime && (
            <IconButton
              size="small"
              onClick={() => cart.setScheduledTime(null)}
              sx={{ color: 'primary.main' }}
            >
              <CancelOutlined />
            </IconButton>
          )}
        </Box>
      )}
    />
  );
}

export default ScheduleButton;
